/**
 * Registry für Zugriffstoken und gewählte App.
 *
 * Bricht die Zyklen zwischen API- und Auth-Schicht: Die Auth-Schicht registriert beim Start
 * beide Provider, die API-Schicht konsumiert sie. Pendant zu den Abhängigkeiten
 * `IAccessTokenProvider` und `AuthService.CurrentApp` des Altclients.
 */

export type TokenProvider = (scopes: string[]) => Promise<string | null>;

export type CurrentAppUriProvider = () => string | undefined;

/** Es ist keine App gewählt — jeder App-bezogene Pfad ist damit nicht bildbar. */
export class MissingCurrentAppError extends Error {
  constructor(message = 'Es ist keine App ausgewählt.') {
    super(message);
    this.name = 'MissingCurrentAppError';
  }
}

let tokenProvider: TokenProvider | null = null;
let currentAppUriProvider: CurrentAppUriProvider | null = null;

export function setTokenProvider(provider: TokenProvider): void {
  tokenProvider = provider;
}

export function setCurrentAppUriProvider(provider: CurrentAppUriProvider): void {
  currentAppUriProvider = provider;
}

/** Liefert das Zugriffstoken für die Scopes oder `null`, wenn keines verfügbar ist. */
export async function acquireToken(scopes: string[]): Promise<string | null> {
  if (tokenProvider === null) {
    return null;
  }
  return tokenProvider(scopes);
}

export function getCurrentAppUri(): string {
  const uri = currentAppUriProvider?.();
  if (uri === undefined) {
    throw new MissingCurrentAppError();
  }
  return uri;
}
